"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDoc = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
const CategoryChooser_1 = require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
require("../../../TdWebtoolkitControls/controls/Mail/Mail");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
require("../../../TdWebtoolkitControls/controls/Upload/Templates");
require("../../../TdWebtoolkitControls/controls/Upload/Upload");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const ModificationInfo_1 = require("../../../TdWebtoolkitControls/model/ModificationInfo");
const $ = require("jquery");
const m = require("../SynView");
class newDoc extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_urlInstanceValues = {};
        this.m_useInitialFiles = false;
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        let that = this;
        that.m_parentId = decodeURIComponent($.address.parameter("parentId") || "");
        that.m_relId = Number($.address.parameter("relId"));
        that.m_useInitialFiles = decodeURIComponent($.address.parameter("initialFiles")) === "true" ? true : false;
        if ($.address.parameter("typeid")) {
            Cookies.set("lastCat_newWithTemplate", $.address.parameter("typeid"), { expires: 356 });
            // templateId URL parameter is ignored if there is no typeid URL parameter. It would not make
            // sense, as we have no way to know if the given template is even valid for the current category,
            // as the current category can be set via cookie.
            if ($.address.parameter("templateId"))
                that.m_templateId = decodeURIComponent($.address.parameter("templateId") || "");
        }
        $.each($.address.parameterNames(), (idx, paramName) => {
            if (/\./.test(paramName) && $.address.parameter(paramName))
                that.m_urlInstanceValues[paramName.toLowerCase()] = decodeURIComponent($.address.parameter(paramName));
        });
    }
    renderContents() {
        let that = this;
        that.m_$categoryChooser = that.m_$container.find(".CategoryChooser");
        that.m_$propertyPage = that.m_$container.find(".PropertyPage");
        that.m_$template = that.m_$container.find(".synTemplateDiv");
        that.m_$uploadContainer = that.m_$container.find(".synUploadDiv");
        that.m_$uploadContainer[0].ondragover = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.dataTransfer && e.dataTransfer.dropEffect)
                e.dataTransfer.dropEffect = 'copy';
        };
        that.m_$categoryChooser
            .off("categoriesReceived").on("categoriesReceived", (evt, cats) => {
            if (cats.length === 0) {
                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("webtoolkit.cannotcreatedocumenthere"));
                that.disableUI(false);
                that.goBack();
            }
        })
            .off("initSuccess").on("initSuccess", (evt) => {
            if (that.m_typeId && that.m_$categoryChooser.synCategoryChooser("hasCategory", parseInt(that.m_typeId, 10)))
                that.m_$categoryChooser
                    .one("categorySelected", (evt, cat) => {
                    if (that.m_templateId)
                        that.m_$template.one("templatesReceived", () => {
                            that.m_$template.synTemplates("setSelectedTemplateId", that.m_templateId);
                        });
                    that.changeCategory(cat);
                })
                    .synCategoryChooser("setSelectedCategory", parseInt(that.m_typeId, 10), false, true);
            else
                that.changeCategory(that.m_$categoryChooser.synCategoryChooser("getSelectedCategory"));
        })
            .off("categorySelectedManually").on("categorySelectedManually", function (event, cat) {
            that.changeCategory(cat);
        })
            .css("width", "400px")
            .synCategoryChooser({
            showIcons: true,
            showTreeButton: true,
            showDependsCheckbox: false,
            parentId: that.m_parentId,
            parentRelId: that.m_relId,
            selectionCookieName: "newWithTemplate"
        });
        let importFiles = [];
        if ($(".staticButtons .mails").data("synMail"))
            importFiles = $(".staticButtons .mails").synMail("getAttachmentsToImport");
        let fileDragAndDrop = sessionStorage.getItem("TabsFileDragAndDrop");
        if (fileDragAndDrop) {
            importFiles = JSON.parse(fileDragAndDrop);
            sessionStorage.removeItem("TabsFileDragAndDrop");
        }
        that.m_$uploadContainer
            .off("uploadComplete").on("uploadComplete", function (event) {
            if (!that.m_$template.prop("disabled"))
                that.m_$template.synTemplates("selectIndex", 0);
        })
            .synUpload({
            allowMultiple: false,
            initialFiles: that.m_useInitialFiles === true ? importFiles : []
        });
        // On mail attachment import do not auto select a default template as that would overwrite the attachment file (AA8135)
        that.m_$template
            .off("templateSelected").on("templateSelected", function (event, templateId) {
            if (!that.m_$uploadContainer.prop("disabled"))
                that.m_$uploadContainer.synUpload("clearList", true);
        })
            .synTemplates({
            ignoreDefaultTemplate: importFiles.length > 0 || that.m_templateId
        });
        // Begin PropertyPage
        that.m_$propertyPage
            .off("instanceChanged").on("instanceChanged", () => {
            that.raiseOnViewResize();
            if (Object.keys(that.m_urlInstanceValues).length > 0)
                that.m_$propertyPage.synPropertyPage("changeInstance", that.m_urlInstanceValues);
        })
            .off("endSetTemplate").on("endSetTemplate", () => {
            window.waitConditions.set("propertyPageReady.newDoc");
        })
            .synPropertyPage({
            checkForUnsavedChanges: true,
            layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table"
        });
        that.askSaveChanges(true, (saveResult) => {
            that.m_$propertyPage.synPropertyPage("deleteUnsavedChanges");
            if (saveResult !== m.ViewSaveResult.Cancel && !that.m_saveInProgress) {
                that.m_saveInProgress = true;
                let fileGUIDs = that.m_$uploadContainer.synUpload("getFileGuids");
                Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.saveAndClose");
                that.m_$propertyPage.synPropertyPage("commitChanges", {
                    fileGUIDs: that.m_$uploadContainer.synUpload("getFileGuids"),
                    templateId: that.m_$template.synTemplates("getSelectedTemplateId"),
                    success(currentInstance, commitResult) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let parentInstance;
                            if (that.m_parentId)
                                parentInstance = yield Utilities_1.synUtil.getInstanceAsync(that.m_parentId);
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    that.CommandTriggerTarget.trigger("forceRefresh", [{
                                            fullRefreshNecessary: false,
                                            modifiedInstances: [currentInstance]
                                        }]);
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    if (importFiles.length)
                                        $(".staticButtons .mails").synMail("attachmentsImported", $.map(importFiles, (elem) => elem.fileGuid));
                                    that.CommandTriggerTarget.trigger("forceRefresh", [{
                                            fullRefreshNecessary: false,
                                            new: {
                                                parent: parentInstance,
                                                action: ModificationInfo_1.ModificationAction.Object,
                                                instances: [currentInstance],
                                                relation: that.m_relId
                                            }
                                        }]);
                                    if (saveResult === m.ViewSaveResult.Save)
                                        window.location.href = "#/properties?id=" + currentInstance.id.value;
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                            that.m_saveInProgress = false;
                            if ($(".staticButtons .mails").data("synMail"))
                                $(".staticButtons .mails").synMail("attachmentsImported", fileGUIDs);
                            that.disableUI(false);
                            that.raiseOnViewHistory(currentInstance.id.valueAsString, currentInstance.name.valueAsString, false);
                            if (saveResult === m.ViewSaveResult.SaveAndClose)
                                that.goBack();
                        });
                    },
                    cleanUp() {
                        that.m_saveInProgress = false;
                        Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.saveAndClose");
                        Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                    },
                    updatePropertyPageAfterCommit: false
                });
            }
            else if (saveResult === m.ViewSaveResult.Cancel) {
                if ($(".staticButtons .mails").data("synMail"))
                    $(".staticButtons .mails").synMail("attachmentsImportCancelled");
                that.disableUI(false);
                that.goBack();
            }
        });
    }
    forceRefresh(modifications) { }
    //#endregion Inherited from SynView
    //#region Helpers
    changeCategory(category) {
        this.updatePropertyPage(category);
        this.updateUpload(category);
        this.updateTemplates(category);
    }
    updatePropertyPage(cat) {
        if (cat) {
            this.m_$propertyPage.synPropertyPage("setTemplate", {
                mode: Base_1.PropertyPageMode.New,
                typeId: cat.id,
                parentId: this.m_parentId,
                parentRelId: this.m_relId
            });
        }
    }
    updateUpload(cat) {
        if (cat) {
            this.m_$uploadContainer.synUpload("setCategory", cat.id);
            if (cat.contentMode !== CategoryChooser_1.ContentAllowedMode.Yes || "Y" === Utilities_1.synUtil.Configs.getValue("webtoolkitdisablefileuploadonnew", undefined, cat.id)) {
                this.m_$uploadContainer.hide();
                this.m_$uploadContainer.synUpload("clearList", true);
                this.m_$uploadContainer.synUpload("enable", false);
            }
            else {
                this.m_$uploadContainer.show();
                this.m_$uploadContainer.synUpload("enable", true);
            }
        }
    }
    updateTemplates(cat) {
        if (cat) {
            if (cat.contentMode !== CategoryChooser_1.ContentAllowedMode.Yes || "Y" === Utilities_1.synUtil.Configs.getValue("webtoolkitdisablefileuploadonnew", undefined, cat.id)) {
                this.m_$template.hide();
                this.m_$template.synTemplates("clearTemplateSelection");
                this.toggleTemplateUpdatePane(true);
            }
            else {
                this.m_$template.show().synTemplates("setCategory", cat.id);
                this.toggleTemplateUpdatePane(false);
            }
        }
    }
    toggleTemplateUpdatePane(collapse) {
        if ("phone" === this.m_clientDeviceClass)
            return;
        let divs = this.m_$container.children("div.k-pane");
        let paneindex = divs.length - 1;
        if (divs && divs.length > 1) {
            let $div = $(divs[paneindex]);
            let id = $div.attr("id");
            if (id) {
                // Get panes of kendosSplitter
                let panes = this.m_$container.data("kendoSplitter").options.panes;
                if (panes && panes.length >= paneindex + 1) {
                    // Set collapsible property of last pane
                    panes[paneindex].collapsible = collapse;
                    this.togglePane($("#" + id), collapse);
                }
            }
        }
    }
}
exports.newDoc = newDoc;
